import { createFileRoute } from "@tanstack/react-router";
import ForumTopic from "@/pages/ForumTopic";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/forum/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/forum/:slug' }),
  component: ForumTopic,
});
